/**
 * Options partagées « secteur d'activité » et « taille d'entreprise » pour les selects
 * B2B (wizard de cas, onboarding, Mon compte). Source unique — ne pas dupliquer ailleurs.
 */

export const INDUSTRY_OPTIONS = [
  "Administration - fonction publique",
  "Agroalimentaire",
  "Artisanat d'art",
  "Associations",
  "Banques – assurances - services financiers",
  "Chimie - plastique - conditionnement",
  "Commerce de détail - grande distribution",
  "Communication - marketing - information",
  "Construction – bâtiment - travaux publics",
  "Culture – sports – loisirs",
  "Energie",
  "Enseignement - formation",
  "Environnement – récupération – tri – recyclage - traitement des déchets – matériaux - de l'eau",
  "Équipement - matériel pour activités professionnelles",
  "Fabrication - commerce de gros d'articles destinés à la vente",
  "Gestion - administration des entreprises",
  "Hôtellerie - restauration - tourisme",
  "Immobilier",
  "Industrie textile",
  "Informatique",
  "Ingénieurs d'études et de recherche - chercheurs",
  "Logistique - transports",
  "Matériel électrique – électronique - optique",
  "Mécanique, métallurgie",
  "Minerais – minéraux - sidérurgie",
  "Professions juridiques",
  "Santé, action sociale",
  "Services aux particuliers – collectivités - entreprises",
];

export const COMPANY_SIZE_OPTIONS = [
  "Micro-entreprises",
  "TPE/TPI",
  "PME/PMI",
  "ETI",
  "Grandes entreprises",
  "Secteur public",
];
